import { MessageDescriptor, useIntl } from 'react-intl'
import { DASH_SYMBOL } from 'app/consts'
import {
  DeviceInfoPropertyContainer,
  StyledLabel,
  StyledPropertyValue,
} from '../styles'

interface DeviceMainInformationCardProps {
  label: MessageDescriptor
  value: string | undefined
}

function DeviceMainInformationCard({
  label,
  value,
}: DeviceMainInformationCardProps) {
  const { formatMessage } = useIntl()
  if (!value || value === DASH_SYMBOL) return null

  return (
    <DeviceInfoPropertyContainer>
      <StyledLabel>{formatMessage(label)}</StyledLabel>
      <StyledPropertyValue>{value}</StyledPropertyValue>
    </DeviceInfoPropertyContainer>
  )
}

export default DeviceMainInformationCard
